import React from "react";
import Collapsible from "../../collapsible";
import _, {isEqual} from "lodash";
import {withPropsChecker} from "../../../lib/utils";
//import withPropsChecker from "../../../../lib/utils";

export const MDCollapsibleText = ({
  text,
  title = "",
  visibleCharNum = 200,
  minimumHidden = 100,
  markText = null,
  toggle = "more", // "more" | "disclosure" | "title"
  showPreview = true,
  ...props
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleTitleClick = () => {
    if (toggle === 'title') {
      setIsOpen(!isOpen);
    }
  };

  return (
    <div className="sr-desc">
      {title ? (
        <span
          className={`source-link-b-title${toggle === 'title' ? ' activate-title' : ''}`}
          onClick={handleTitleClick}
          style={toggle === 'title' ? { cursor: 'pointer' } : undefined}
        >
          {markText ? markText(title) : title}
        </span>
      ) : null}
      <Collapsible
        type="text"
        item={`${text}`.trim()}
        visibleNum={visibleCharNum}
        minimumHidden={minimumHidden}
        markText={markText}
        toggle={toggle}
        showPreview={showPreview}
        isOpen={toggle === 'title' ? isOpen : undefined}
      />
    </div>
  );
};

export const MDCollapsibleList = ({
  list = [],
  title = "",
  initVisibleNum = 3,
  minimumHidden = 2,
  markText = null,
  abbreviate = true,
  openWhenMarked = true,
}) => (list && list.length) ? (
  <div className="sr-desc">
    {title ? <span className="source-link-b-title">{markText ? markText(title) : title}</span> : null}
    <Collapsible
      type="list"
      item={list}
      visibleNum={initVisibleNum}
      minimumHidden={minimumHidden}
      markText={markText}
      abbreviate={abbreviate}
      openWhenMarked={openWhenMarked}
    />
  </div>
) : null;
